import { MODEL_KEY } from '../../../modules/model/constants'

export const CHAT_CLASS_NAME = 'Chat'

export const CHAT_KEY = {

  ...MODEL_KEY,

  NAME: 'name',
  STATUS: 'status',
  TYPE: 'type',
  CHAT_PROFILES: 'chatProfiles',
  MESSAGES_COUNT: 'messagesCount',
  USERS_COUNT: 'usersCount',
  ARCHIVED_AT: 'archivedAt',

  // Associations
  IMAGE: 'image',
  LAST_MESSAGE: 'lastMessage',

  // Foreign keys
  PROFILE_ID: 'profileId',
  IMAGE_ID: 'imageId'

}

export const CHAT_PRIVATE_KEYS = []

export const CHAT_STATUS = {

  // General
  OPEN: 1,
  IN_PROGRESS: 2,
  CLOSED: 3

}

export const CHAT_TYPE = {
  GROUP: 1
}

export const CHAT_SCOPE = {

  /**
   * Only returns the public attributes of the Post.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: CHAT_PRIVATE_KEYS
    }
  }

}

export const CHAT_AUDIT = {
  CREATED: 'Chat Created',
  UPDATED: 'Chat Updated',
  DELETED: 'Chat Deleted'
}
